import React from 'react';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from "react-localize-redux";
import { chartActions } from '../../store/charts/chartsStore';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames'

class ChartWarningsLegend extends React.Component {
    render() {
        return (
            <>
                <div style={{ padding: '0 5px 5px 0' }}>
                    <strong style={{ paddingLeft: '5px' }}><Translate id="Charts.ExportShortcutOverview" /></strong>
                </div>
                <div id="divWarningShortcuts">
                    <input type="hidden" id="profiVersionSelected" value="false" />
                    {this.props.topPanel.isProfi === true && <ul id="warningsStatusesProfi" className="list-unstyled warn-profi" style={{ fontSize: '11px' }}>
                        <li><span className="warn-item warn-status-05">R</span>&nbsp;<Translate id="Charts.RedBoldDesc" /></li>
                        <li><span className="warn-item warn-status-03">R</span>&nbsp;<Translate id="Charts.BlackBoldDesc" /></li>
                        <li><span className="warn-item warn-status-02">R</span>&nbsp;<Translate id="Charts.BlackBoldItalicDesc" /></li>
                        <li><span className="warn-item warn-status-01">R</span>&nbsp;<Translate id="Charts.BlackNormalDesc" /></li>
                        <li><span className="warn-item warn-status-00">R</span>&nbsp;<Translate id="Charts.GrayItalicDesc" /></li>
                        <li><span className="warn-item warn-status-0x">R</span>&nbsp;<Translate id="Charts.InfoNormalDesc" /></li>
                        <li><span className="warn-item warn-status-0y">R</span>&nbsp;<Translate id="Charts.InfoItalicDesc" /></li>
                    </ul>}
                    {this.props.topPanel.isProfi !== true && <ul id="warningsStatusesNormal" className="list-unstyled" style={{ fontSize: '11px' }}>
                        <li><span className="warn-item warn-status-05"><Translate id="Charts.Red" /></span>&nbsp;<Translate id="Charts.RedDesc" /></li>
                        <li><span className="warn-item warn-status-00"><Translate id="Charts.Gray" /></span>&nbsp;<Translate id="Charts.GrayDesc" /></li>
                        <li><span className="warn-item warn-status-0x"><Translate id="Charts.LightGray" /></span>&nbsp;<Translate id="Charts.InfoDesc" /></li>
                    </ul>}

                    <table className="tableWarningShortcuts">
                        <thead>
                            <tr>
                                <th><Translate id="Charts.WarningTableHelpAbbreviation" /></th>
                                <th><Translate id="Charts.WarningTableHelpDescription" /></th>
                                <th><Translate id="Charts.WarningTableHelpSource" /></th>
                            </tr>
                        </thead>
                        {this.props.bottomWindow.negInfo.data && <tbody className={classnames({ 'warn-profi': (this.props.topPanel || {}).isProfi === true })}>
                            {this.renderNiLegend(this.props.bottomWindow.negInfo.data)}
                        </tbody>}
                    </table>
                </div>
            </>
        );
    }

    renderNiLegend = (data) => {
        var warningsToRender = [];

        data.forEach(function (value) {
            value.warnings.forEach(function (warning) {
                if (!warningsToRender.map(function (el) { return el.code + '|' + el.normalized; }).includes(warning.WarningsCode + '|' + warning.NormalizedDescription)) {
                    warningsToRender.push({
                        code: warning.WarningsCode,
                        description: warning.Description,
                        source: warning.SourceDescription,
                        normalized: warning.NormalizedDescription
                    });
                }
            });
        });

        return warningsToRender.sort(function (a, b) {
            if (a.code == b.code) { return a.normalized == b.normalized ? 0 : a.normalized < b.normalized ? -1 : 1; }
            return a.code == b.code ? 0 : a.code < b.code ? -1 : 1;
        }).map((value, i) => <tr key={i}><td>{value.code}</td><td>{value.description}</td><td>{value.source}</td></tr>);
    }
}

export default withRouter(withLocalize(connect(
    state => state.charts,
    dispatch => bindActionCreators(chartActions, dispatch)
)(ChartWarningsLegend)));
